// extracted by mini-css-extract-plugin
export default {"button-submit":"TripChecklist_button-submit__1+x5V","flex":"TripChecklist_flex__hXsf7","divider":"TripChecklist_divider__qoK+r"};